import { render, staticRenderFns } from "./RecoverDemo.vue?vue&type=template&id=c77ce834&"
import script from "./RecoverDemo.vue?vue&type=script&lang=js&"
export * from "./RecoverDemo.vue?vue&type=script&lang=js&"
import style0 from "./RecoverDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports